import { gql } from '@apollo/client';

// TODO: improve sortingValues query: add sorting values request to the schema
export default gql`
  fragment menuOptionFields on TopMenu {
    slug
    title
    protected
    link
    description
    query
    terms {
      title
      body
    }
    meta {
      title
      description
      image
      imageAlt
    }
  }

  fragment menuOption on TopMenu {
    ...menuOptionFields
    children {
      ...menuOptionFields
    }
  }

  query FiltersAndMenuConfig(
    $language: Language
    $variant: String
    $previewToken: String
  ) {
    sortingValues
    menu(variant: $variant, previewToken: $previewToken, language: $language) {
      ...menuOption
      children {
        ...menuOption
        children {
          ...menuOption
        }
      }
    }
  }
`;
